<template>
  <div class="action-bar">
    <div class="action-bar__left">
      <slot name="left">
        <el-button
          v-if="showAdd"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          {{ addText }}
        </el-button>
        <slot name="left-extra" />
      </slot>
    </div>
    <div class="action-bar__right">
      <slot name="right">
        <el-button
          v-if="showImport"
          icon="el-icon-upload2"
          @click="handleImport"
        >
          导入
        </el-button>
        <el-button
          v-if="showExport"
          icon="el-icon-download"
          @click="handleExport"
        >
          导出
        </el-button>
        <el-button
          v-if="showSettings"
          class="icon-button icon-button--settings"
          icon="el-icon-setting"
          @click="handleSettings"
        />
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionBar',
  props: {
    showAdd: {
      type: Boolean,
      default: false
    },
    addText: {
      type: String,
      default: '新增'
    },
    showImport: {
      type: Boolean,
      default: false
    },
    showExport: {
      type: Boolean,
      default: false
    },
    showSettings: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAdd() {
      this.$emit('add')
    },
    handleImport() {
      this.$emit('import')
    },
    handleExport() {
      this.$emit('export')
    },
    handleSettings() {
      this.$emit('settings')
    }
  }
}
</script>

